import React from 'react';
import { Button, Stack } from '@moda/om';
import './FavoriteConfirmRemove.scss';

type FavoriteConfirmRemoveProps = {
  onClose: () => void;
  onConfirm: () => void;
};

export const CONFIRM_MESSAGE = 'Do you really want to remove this item from your wishlist?';

export const FavoriteConfirmRemove: React.FC<FavoriteConfirmRemoveProps> = ({
  onClose,
  onConfirm
}) => {
  return (
    <div className="FavoriteConfirmRemove">
      <Stack space={4}>
        <span>{CONFIRM_MESSAGE}</span>
        <Button onClick={onConfirm}>Remove</Button>
        <Button secondary onClick={onClose}>
          Cancel
        </Button>
      </Stack>
    </div>
  );
};
